import { useState, useEffect, useCallback } from 'react';
// @ts-ignore — CommonJS module from @scoutfdc/common
const ProductTypes = require('@scoutfdc/common/lib/product_types');
const DEFAULT_PRODUCTS = [ProductTypes.oil, ProductTypes.water, ProductTypes.gas];
function isNumberArray(value) {
    return Array.isArray(value) && value.every((item) => typeof item === 'number');
}
export function productsForOrganization(org) {
    var _a;
    const networkLinkDefaults = (_a = org === null || org === void 0 ? void 0 : org.options) === null || _a === void 0 ? void 0 : _a.network_link_defaults;
    if (typeof networkLinkDefaults !== 'object' || networkLinkDefaults === null || !('products' in networkLinkDefaults)) {
        return [...DEFAULT_PRODUCTS];
    }
    return isNumberArray(networkLinkDefaults.products) ? networkLinkDefaults.products : [...DEFAULT_PRODUCTS];
}
export function useNetworkLinkDefaultsField(org) {
    const [selected, setSelected] = useState(() => productsForOrganization(org));
    useEffect(() => {
        setSelected(productsForOrganization(org));
    }, [org]);
    const toggle = useCallback((code, checked) => {
        setSelected((previous) => {
            if (checked) {
                return previous.includes(code) ? previous : [...previous, code];
            }
            return previous.filter((productCode) => productCode !== code);
        });
    }, []);
    const reset = useCallback(() => {
        setSelected(productsForOrganization(org));
    }, [org]);
    const toOptionsPatch = useCallback(() => ({
        network_link_defaults: { products: selected },
    }), [selected]);
    return { selected, toggle, reset, toOptionsPatch };
}
